import './style.css';
// import omelette from './images/image-omelette.jpeg'

console.log("This is an exercise in webpack!");

